import Image from '@anm/components/image/Image';
import { flexCenter, stretchBlock } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { SocialAvatarVariant } from './index';

export const UserImage = styled(Image)`
  object-fit: cover;
  border-radius: 50%;
`;

export const SocialImage = styled(Image)`
  top: 0;
  height: 100%;
  position: absolute;
`;
export const D = styled.div`
  width: 100%;
  height: 100%;
  ${flexCenter}
`;

export const DestinationWrapper = styled.div<{ iconHeight: number }>`
  z-index: 2;
  background: #fff;
  position: absolute;
  border-radius: 5px;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: ${({ iconHeight }) => iconHeight}px;
  }
`;

export const DestinationBorder = styled.div`
  border: 1px solid #00385733;
  height: inherit;
  z-index: 3;
  position: relative;
  border-radius: 5px;
  width: 100%;
`;

export type WrapperProps = {
  variant: SocialAvatarVariant;
  isSelected?: boolean;
  isSelectList?: boolean;
};

const variants: { [key in SocialAvatarVariant]: ReturnType<typeof css> } = {
  '50x50': css`
    ${UserImage} {
      width: 54px;
      height: 54px;
    }
    ${DestinationWrapper} {
      right: -15px;
      bottom: -15px;
      width: 45px;
      height: 40px;
    }
  `,
  '30x30': css`
    ${UserImage} {
      width: 30px;
      height: 30px;
    }
    ${DestinationWrapper} {
      right: -6px;
      bottom: -2px;
      width: 16px;
      height: 16px;
    }
  `
};

const selectedStyles = css`
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid var(--blue_100);
`;

const notSelectedStyles = css`
  opacity: 0.6;
  cursor: pointer;
  border: 3px solid transparent;
`;

export const UserImageContainer = styled.div<WrapperProps>`
  position: relative;
  align-items: center;
  ${flexCenter};
  ${({ variant }) => variants[variant]}
  ${({ isSelected }) => isSelected && selectedStyles};
  ${({ isSelectList, isSelected }) => isSelectList && !isSelected && notSelectedStyles}

  &:after {
    content: '';
    z-index: 1;
    ${stretchBlock};
    border-radius: 50%;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border: 1px solid rgba(0, 56, 87, 0.2);
  }
`;
